import "./OrderFormMailbox.scss";
import { useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { NotificationManager } from "react-notifications";
import { useLangContext } from "../../context/languageContext";
import { Link, useParams } from "react-router-dom";
import {
    postInquiry,
    getPricingMailCountries,
    getPricingMailCitiesById,
    getPricingMailContractPeriodsAndPlansById,
    getPageContent
} from "../../api/apiRequest";
import { Tag } from "../../utils/GTMPageTag";
import { Col } from "react-bootstrap";

const today = new Date()
const year = today.getFullYear() 
const month = (today.getMonth() + 1 < 10 ? "0"+ (today.getMonth() + 1) : today.getMonth() + 1 )
const day = (today.getDate() < 10 ? "0"+ today.getDate() : today.getDate() ) 
const todayFormatted = year + '-' + month + '-' + day

const OrderFormMailbox = (props) => {
    Tag("OrderFormMailbox")
    const navigateLink = props.navigateLink ?? '/Order/Mailbox';
    const { hostLanguage, languageJson } = useLangContext();
    const { country, city, type } = useParams();

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(country ?? "");
    
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(city ?? "");

    const [contractPlans,setContractPlans] = useState([]);
    
    const [contractRuntimes,setContractRuntimes] = useState([]);
    const [selectedContractRuntime, setContractRuntime] = useState(null);
    const [contractsFiltered,setContractsFiltered] = useState([]);
    const [selectedContract, setSelectedContract] = useState(null);

        //API
    const getAllCountries = async () => {
        try {
            let apiRes = await getPricingMailCountries();
            let responseData = await apiRes.json();
            if (responseData.res) {
                const countriesArray = Object.values(responseData.data).flat(); //Object to Array Conversation
                setCountries(countriesArray);
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    };
    const getAllCities = async (countryUsed) => {
        try {
            let apiRes = await getPricingMailCitiesById(countryUsed);
            let responseData = await apiRes.json();
            if (responseData.res) {
                const citiesArray = Object.values(responseData.data).flat(); //Object to Array Conversation
                setCities(citiesArray);
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    };

    function getAllContractPlanDetailsWithParentInfo(plans, sortBy = "price", order = "asc") {
        const flattened = plans.flatMap(plan =>
            plan.contract_plan_details.map(detail => ({
            ...detail,
            plan_id: plan.id,
            plan_name: plan.name,
            plan_additional_info: plan.additional_info,
            }))
        );

        return flattened.sort((a, b) => {
            let valA = a[sortBy];
            let valB = b[sortBy];

            // Handle string case-insensitive sorting
            if (typeof valA === "string") valA = valA.toLowerCase();
            if (typeof valB === "string") valB = valB.toLowerCase();

            if (valA < valB) return order === "asc" ? -1 : 1;
            if (valA > valB) return order === "asc" ? 1 : -1;
            return 0;
        })
    }
    const getAllContractPlans = useCallback(async (country, city) =>{
        try {
            let apiRes = await getPricingMailContractPeriodsAndPlansById(
                country,
                city,
                hostLanguage
            );

            let responseData = await apiRes.json();
            if (responseData.res) {
                setContractPlans(getAllContractPlanDetailsWithParentInfo(responseData.data, "period", "asc"));
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    }, [hostLanguage]);

    const sendInquire = async () => {
        let countryName = countries.find(item => item.country.id === parseInt(selectedCountry))?.country?.name;
        let cityName = cities.find(item => item.city.id === parseInt(selectedCity))?.city?.name;
        let contractDurationName = contractRuntimes.find(item => item.id === parseInt(selectedContractRuntime))?.name;
        let accountTypeName = contractPlans.find(item => item.id === parseInt(selectedContract))?.title;

        let formData = {
            "type": "mailbox",
            "lang": hostLanguage,
            //Customer Details
            "customer": {
                "company": customerCompany,
                "name": customerName,
                "street": customerStreet,
                "postcode_city": customerCity,
                "country": customerCountry,
                "phone": customerPhone,
                "email": customerMail,
                "message": customerMessage
            },
            //Product Details
            "product": {
                "country": countryName,
                "city": cityName,
                "contract_duration": contractDurationName,
                "account_type": accountTypeName,
                "accept_packages": packages,
                "scan_service": scan,
                "forwarding": forwarding,
                "mailboxName": mailboxName
            },
            //Payment Details
            "payment": {
                "starting": starting,
                "payment_method": paymentMethod,
                "gross": 0,
                "tax": tax.toFixed(2),
                "net": net.toFixed(2),
                "tax_rate": taxRate,
            }
        };

        if( customerName === "" || customerMail === "" || customerPhone === "" ){
            NotificationManager.error(contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.requiredFieldsMissing, "", 10000);
            return;
        }

        let apiRes = await postInquiry(formData);
        let responseData = await apiRes.json();
        if (responseData.res) {
            NotificationManager.success(responseData.msg, "", 2000);
            window.location.href = '/danke';
        }else{
            NotificationManager.error(responseData.msg, "", 2000);
        }
    };

    useEffect(() => {
        setCities([]);
        getAllCities(selectedCountry);
        window.history.replaceState({}, null, navigateLink+'/'+selectedCountry);
    },[navigateLink, selectedCountry]);


    useEffect(() => {
        if(cities.length>0){
            if(cities.find(item => item.city_id === parseInt(selectedCity)) === undefined){
                setSelectedCity(cities[0].city_id);
            }
        }
    },[cities, selectedCity]);

    useEffect(() => {
        if(selectedCity !== null && selectedCity !== ""){
            getAllContractPlans(selectedCountry, selectedCity)
            window.history.replaceState({}, null, navigateLink+'/'+selectedCountry+'/'+selectedCity);
        }
    }, [navigateLink, selectedCity, getAllContractPlans, selectedCountry]);

    useEffect(() => {
        if(contractPlans.length>0){
            //Runtimes
            const seen = new Set();
            const result = [];
            contractPlans.forEach(item => {
                if (!seen.has(item.contract_period_id)) {
                seen.add(item.contract_period_id);
                result.push({
                    id: item.contract_period_id,
                    name: item.plan_name,
                    additional_info: item.plan_additional_info,
                });
                }
            });
            setContractRuntimes(result);
        }
    }, [contractPlans]);
    
    useEffect(() => {
        if(contractRuntimes.length>0){
            if(type !== undefined && type !== null){
                const presetPlan = contractPlans.find(item => item.id === parseInt(type));
                if(presetPlan === undefined){
                    setContractRuntime(contractRuntimes[0].id)
                }else{
                    setContractRuntime(presetPlan.contract_period_id)
                }
            }else{
                setContractRuntime(contractRuntimes[0].id)
            }
        }
    }, [contractRuntimes, contractPlans, type]);

    
    useEffect(() => {
        if(contractPlans.length>0){
            setContractsFiltered(contractPlans.filter(item => item.contract_period_id === parseInt(selectedContractRuntime)));
        }
    }, [selectedContractRuntime, contractPlans]);
    
    useEffect(() => {
        console.log(contractsFiltered);
        console.log(type);
        if(contractsFiltered.length>0){
            if(type !== undefined && type !== null){
                if(contractsFiltered.find(item => item.id === parseInt(type)) === undefined){
                    setSelectedContract(contractsFiltered[0].id)
                }else{
                    setSelectedContract(type);
                }
            }else{
                setSelectedContract(contractsFiltered[0].id)
            }
        }
    }, [contractsFiltered, type]);

    const [net, setNet] = useState(0);
    const [taxRate, setTaxRate] = useState(0);
    const [tax, setTax] = useState(0);

    useEffect(() => {
        if(selectedContract !== null && contractPlans !== undefined){
            window.history.replaceState({}, null, navigateLink+'/'+selectedCountry+'/'+selectedCity+'/'+selectedContract);

            const contract = contractPlans.find(item => item.id === parseInt(selectedContract));
            setNet(contract?.price)
            setTaxRate(parseInt(contract?.vat_charge))
            setTax((net / (100+taxRate)) * 100)

        }
    }, [navigateLink, selectedContract, contractPlans, net, selectedCity, selectedCountry, taxRate]);

    const [packages, setPackages] = useState("");
    const [scan, setScan] = useState("");
    const [forwarding, setForwarding] = useState("");
    const [mailboxName, setMailboxName] = useState("");
    const [starting, setStarting] = useState(todayFormatted);
    const [customerCompany, setCustomerCompany] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerStreet, setCustomerStreet] = useState("");
    const [customerCity, setCustomerCity] = useState("");
    const [customerCountry, setCustomerCountry] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [customerMail, setCustomerMail] = useState("");
    const [customerMessage, setCustomerMessage] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");

    
    //PAGE INIT
    const [contentDetails, setContentDetails] = useState();
    const getAllPageContent = useCallback(async () => {
        try {
            let apiRes = await getPageContent(hostLanguage, "pricing_mail_box_page_data_inquiry_mailbox");
            let responseData = await apiRes.json();
            if (responseData.res) {
                setContentDetails(responseData.data);

                setPackages(responseData.data?.pricing_mail_box_page_data_inquiry_mailbox?.no)
                setScan(responseData.data?.pricing_mail_box_page_data_inquiry_mailbox?.no)
                setForwarding(responseData.data?.pricing_mail_box_page_data_inquiry_mailbox?.monthly)
                setPaymentMethod(responseData.data?.pricing_mail_box_page_data_inquiry_mailbox?.invoice)
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            console.error(error);
        }
    },[hostLanguage]);

    useEffect(() => {
        getAllPageContent();
        getAllCountries();
    }, [hostLanguage, getAllPageContent]);
    return(
        <div id="OrderAddress" className="container">
            <div className="DigitalmailboxinLftCheckBox DigitalmailboxinLftCheckBox5 row">
                <Col sm={12} md={6}>
                    <Form.Select
                        value={selectedCountry}
                        onChange={(e) => setSelectedCountry(e.target.value)}
                    >
                        <option value="" hidden>
                            {contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.tab_1_select_box_1_default_text}
                        </option>
                        {countries?.length > 0 ? (
                            countries?.map((item, idx) => {
                                return (
                                        <option key={idx} value={item?.country_id}>
                                            {item?.country_name}
                                        </option>
                                    );
                                })
                            ) : (
                            // <option disabled>No Countries Found</option>
                            <option disabled>
                                {languageJson?.countryNotFound}
                            </option>
                            )
                        }
                    </Form.Select>
                </Col>
                <Col sm={12} md={6}>
                    <Form.Select
                        value={selectedCity}
                        onChange={(e) => {setSelectedCity(e.target.value)}}
                    >
                        <option value="" hidden>
                            {contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.tab_1_select_box_2_default_text}
                        </option>
                        {cities?.length > 0 ? (
                            cities?.map((item, idx) => {
                                return (
                                        <option key={idx} value={item?.city?.id}>
                                            {item?.city?.name}
                                        </option>
                                    );
                                })
                            ) : (
                            // <option disabled>No Countries Found</option>
                            <option disabled>
                                {languageJson?.cityNotFound}
                            </option>
                            )
                        }
                    </Form.Select>
                </Col>
            </div>
            {contractRuntimes.length > 0 ?
                <div className="Content row">
                    <Col sm={12} md={6} className="LeftBox">
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_contractDuration}</h4>
                            <div>
                                {contractRuntimes.map((value, idx) => {
                                    return (
                                        <span key={idx} className="d-block col-12">
                                            <input 
                                                id={"contractDuration"+idx} 
                                                className="me-2"
                                                type="radio" 
                                                value={value.id} 
                                                checked={selectedContractRuntime === value.id}
                                                onChange={(e) => {setContractRuntime(parseInt(e.target.value))}}
                                            />
                                            <label htmlFor={"contractDuration"+idx}>{value.name} ({value.additional_info})</label>
                                        </span>
                                    )
                                })}
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_accountType}</h4>
                            <div>
                                {contractsFiltered.map((value, idx) => {
                                    return (
                                        <span key={idx} className="d-block col-12 ">
                                            <input 
                                                id={"accountType"+idx} 
                                                className="me-2"
                                                type="radio" 
                                                value={value.id} 
                                                checked={parseInt(selectedContract) === value.id}
                                                onChange={(e) => {setSelectedContract(e.target.value)}}
                                            />
                                            <label htmlFor={"accountType"+idx}>{value.title}</label>
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_acceptPackages}</h4>
                            <div>
                                <span className="d-block col-12">
                                    <input 
                                        id={"packages0"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.yes} 
                                        checked={packages === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.yes}
                                        onChange={(e) => {setPackages(e.target.value)}}
                                    />
                                    <label htmlFor={"packages0"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.yes}</label>
                                </span>
                                <span className="d-block col-12">
                                    <input 
                                        id={"packages1"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.no} 
                                        checked={packages === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.no}
                                        onChange={(e) => {setPackages(e.target.value)}}
                                    />
                                    <label htmlFor={"packages1"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.no}</label>
                                </span>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_scanService}</h4>
                            <div>
                                <span className="d-block col-12">
                                    <input 
                                        id={"scan0"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.yes} 
                                        checked={scan === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.yes}
                                        onChange={(e) => {setScan(e.target.value)}}
                                    />
                                    <label htmlFor={"scan0"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.yes}</label>
                                </span>
                                <span className="d-block col-12">
                                    <input 
                                        id={"scan1"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.no} 
                                        checked={scan === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.no}
                                        onChange={(e) => {setScan(e.target.value)}}
                                    />
                                    <label htmlFor={"scan1"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.no}</label>
                                </span>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_forwarding}</h4>
                            <div>
                                <span className="d-block col-12">
                                    <input 
                                        id={"forwarding0"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.weekly} 
                                        checked={forwarding === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.weekly}
                                        onChange={(e) => {setForwarding(e.target.value)}}
                                    />
                                    <label htmlFor={"forwarding0"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.weekly}</label>
                                </span>
                                <span className="d-block col-12">
                                    <input 
                                        id={"forwarding1"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.monthly} 
                                        checked={forwarding === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.monthly}
                                        onChange={(e) => {setForwarding(e.target.value)}}
                                    />
                                    <label htmlFor={"forwarding1"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.monthly}</label>
                                </span>
                            </div>
                            <p>*{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.subtitle_forwarding}</p>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_mailboxName}</h4>
                            <div>
                                <input type="text" className="form-control" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.mailboxName} value={mailboxName} onChange={(e) => setMailboxName(e.target.value)}/>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_starting}</h4>
                            <div>
                                <input type="date" className="form-control" value={starting} onChange={(e) => {setStarting(e.target.value)}}/>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox?.title_client}</h4>
                            <div>
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_companyName} value={customerCompany} onChange={(e) => setCustomerCompany(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_name} value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_street} value={customerStreet} onChange={(e) => setCustomerStreet(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_postcode_city} value={customerCity} onChange={(e) => setCustomerCity(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_country} value={customerCountry} onChange={(e) => setCustomerCountry(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_phone} value={customerPhone} onChange={(e) => setCustomerPhone(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_mail} value={customerMail} onChange={(e) => setCustomerMail(e.target.value)} />
                                <textarea rows="5" className="form-control col-sm-12" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.input_message} value={customerMessage} onChange={(e) => setCustomerMessage(e.target.value)} ></textarea>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.title_paymentMethod}</h4>
                            <div>
                                <span className="d-block col-12">
                                    <input 
                                        id={"paymentMethod0"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.invoice} 
                                        checked={paymentMethod === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.invoice}
                                        onChange={(e) => {setPaymentMethod(e.target.value)}}
                                    />
                                    <label htmlFor={"paymentMethod0"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.invoice}</label>
                                </span>
                                <span className="d-block col-12">
                                    <input 
                                        id={"paymentMethod1"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.transfer} 
                                        checked={paymentMethod === contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.transfer}
                                        onChange={(e) => {setPaymentMethod(e.target.value)}}
                                    />
                                    <label htmlFor={"paymentMethod1"}>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.transfer}</label>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} className="RightBox">
                        <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.tab_2_tarifdetails} {contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.inkl_vat}</h4>
                        <ul>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.tab_2_tarifdetails_label_4}</p>
                                <span>{contractRuntimes.find(item => item.id === parseInt(selectedContractRuntime))?.name}</span>
                            </li>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.tab_2_tarifdetails_label_1}</p>
                                <span>{Number(0 ?? 0).toFixed(2)} €</span>
                            </li>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.tab_2_tarifdetails_label_2}</p>
                                <span>{Number(net).toFixed(2)} €</span>
                            </li>
                        </ul>
                        <hr />
                        <ul>
                            <li className="d-flex flex-row justify-content-between">
                                <Link to={"/geschaeftsadresse/"+cities?.find(item => item.city.id === parseInt(selectedCity))?.city?.key}>Detaillierte Preisliste</Link>
                            </li>
                        </ul>
                        <button onClick={sendInquire} className="btn btn-primary">{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.btn_send_inquiry}</button>
                    </Col>
                </div>
            : 
                <div className="text-center">
                    <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_mailbox.noCountry}</h4>
                </div>
            }
        </div>
    );
};

export default OrderFormMailbox;